module.exports = __webpack_public_path__ + "static/img/diyimmove11.8a8e680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/diyimmove11.png
// module id = xz/x
// module chunks = 5